/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Parceiro {
  constructor () {
    this.parceiro_id = uuidV4()
    this.descricao = ''
    this.cnpj_cpf = ''
    this.nome = ''
    this.contato = ''
    this.telefone = ''
    this.logrado = ''
    this.numero = ''
    this.complemento = ''
    this.bairro = ''
    this.cep = ''
    this.municipio_id = ''
    this.observacoes = ''
    this.desativado = false
    this.comissao_mensalidade = 0
    this.comissao_instalacao = 0
    this.tp_chavepix = 1
    this.chavepix = ''
  }
}
